var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-main"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('phone-card-list')],1),_c('div',{staticClass:"col-6"},[_c('edit-window')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }